import React, { createContext, useCallback, useContext, useState } from 'react';

import { AvailableFormFieldValues } from '../types';

type ApplicationEmailAddress = AvailableFormFieldValues['email'] | undefined;
type SetApplicationEmailAddress = (emailAddress: ApplicationEmailAddress) => void;

const ApplicationUpdateEmailAddressContext = createContext<SetApplicationEmailAddress>(() => undefined);
const ApplicationEmailContext = createContext<ApplicationEmailAddress>(undefined);

export const JobApplicationEmailProvider: React.FC = ({ children }) => {
  const [emailAddress, setEmailAddress] = useState<ApplicationEmailAddress>(undefined);

  const setApplicationEmailValue = useCallback((emailAddress: ApplicationEmailAddress): void => {
    setEmailAddress(emailAddress);
  }, []);

  return (
    <ApplicationUpdateEmailAddressContext.Provider value={setApplicationEmailValue}>
      <ApplicationEmailContext.Provider value={emailAddress}>{children}</ApplicationEmailContext.Provider>
    </ApplicationUpdateEmailAddressContext.Provider>
  );
};

export const useSetApplicationEmailValue = (): SetApplicationEmailAddress => {
  return useContext(ApplicationUpdateEmailAddressContext);
};

export const useApplicationEmail = (): ApplicationEmailAddress => {
  return useContext(ApplicationEmailContext);
};
